/* eslint-disable no-restricted-syntax */
import { keyframes } from '@emotion/react';
import { Box, Theme } from '@mui/material';

const bounce = keyframes({ to: { opacity: 0.5, transform: 'translateY(-4px)' } });

const Loading = () => {
  const sx = {
    width: '4px',
    height: '4px',
    margin: '3px 6px',
    borderRadius: '50%',
    backgroundColor: (theme: Theme) => theme.palette.text.secondary,
    opacity: 1,
    animation: `${bounce} 0.6s infinite alternate`,
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ ...sx, animationDelay: '0s' }} />
      <Box sx={{ ...sx, animationDelay: '0.2s' }} />
      <Box sx={{ ...sx, animationDelay: '0.4s' }} />
    </Box>
  );
};

export default Loading;
